import chroma from 'chroma-js'
import { getAllCategoriaDeArvore } from '../services/requests/CategoriaDeArvoreRequests'
import { listarCategoriasDeFitossanidade } from '../services/requests/CategoriaDeFitossanidadeRequests'
import { outliersMessage } from '../utils/enums/OutliersMessage'
import { parseDate, yearsBetween } from '../utils/helpers'

const mixins = {
	async created() {
		try {
			const categorias = await getAllCategoriaDeArvore()

			this.categoriasArvore = categorias.data.result.map((categoria) => {
				return {
					...categoria,
					ctga_tx_cor: categoria.ctga_tx_cor || chroma.random().hex(),
				}
			})

			const categoriaFitossanidade = await listarCategoriasDeFitossanidade()
			this.categoriasFitossanidade = categoriaFitossanidade.data.map((categoria) => {
				return {
					...categoria,
					cor: categoria.cor || chroma.random().hex(),
				}
			})
		} catch (error) {
			console.error('Error fetching categories:', error)
		}
	},

	computed: {
		niveisRisco() {
			return {
				0: 'CORRETO',
				1: 'VERIFICAR',
				2: 'VERIFICAR',
				3: 'RISCO BAIXO',
				4: 'RISCO BAIXO',
				5: 'RISCO MÉDIO',
				6: 'RISCO MÉDIO',
				//MAIOR QUE 6 RISCO ALTO
			}
		},
	},
	data() {
		return { categoriasArvore: [], categoriasFitossanidade: [] }
	},
	methods: {
		idadePlantio(dataPlantio, dataColeta) {
			return yearsBetween(
				!parseDate(dataPlantio).isValid() ? new Date(dataPlantio) : parseDate(dataPlantio),
				!parseDate(dataColeta).isValid() ? new Date(dataColeta) : parseDate(dataColeta),
			)
		},
		setRiscoMedicao(medicao) {
			medicao.nivelRisco = this.niveisRisco[medicao.insights.length] || 'RISCO ALTO'
		},
		validaLimitesDAPxIdade(medicao) {
			if (medicao.dataPlantio && medicao.dataColeta) {
				const idadePlantio = this.idadePlantio(medicao.dataPlantio, medicao.dataColeta)

				const limites = this.limitesDAPxIdade(idadePlantio)

				if (medicao.dap > limites.LAS)
					medicao.insights.push({
						message: outliersMessage.DAP_ACIMA_PLANTIO_IDADE,
						source: limites.LAS,
					})
				if (medicao.dap < limites.LAI)
					medicao.insights.push({
						message: outliersMessage.DAP_ABAIXO_PLANTIO_IDADE,
						source: limites.LAI,
					})
			}
		},
		validaContextoLimitesContexto(medicao) {
			const categorias = this.categoriasArvore
				.filter(
					(categoria) =>
						categoria.ctga_tp_valida_dap === 'C' ||
						categoria.ctga_tp_valida_dap === 'O' ||
						categoria.ctga_tp_valida_ht === 'C' ||
						categoria.ctga_tp_valida_ht === 'O',
				)
				.map((categoria) => categoria.ctga_nm_nome)

			if (categorias.includes(medicao.categoriaDaArvore)) {
				//Estrato
				if (
					this.boxplotDAPESFL &&
					this.boxplotDAPESFL.LAS &&
					medicao.dap > this.boxplotDAPESFL.LAS
				) {
					medicao.insights.push({
						message: outliersMessage.DAP_ACIMA_ESTRATO,
						source: this.boxplotDAPESFL.LAS,
					})
				}

				if (
					this.boxplotDAPESFL &&
					this.boxplotDAPESFL.LAI &&
					medicao.dap < this.boxplotDAPESFL.LAI
				) {
					medicao.insights.push({
						message: outliersMessage.DAP_ABAIXO_ESTRATO,
						source: this.boxplotDAPESFL.LAI,
					})
				}

				if (medicao.ht != null) {
					if (this.boxplotHTESFL && this.boxplotHTESFL.LAS && medicao.ht > this.boxplotHTESFL.LAS) {
						medicao.insights.push({
							message: outliersMessage.HT_ACIMA_ESTRATO,
							source: this.boxplotHTESFL.LAS,
						})
					}

					if (this.boxplotHTESFL && this.boxplotHTESFL.LAI && medicao.ht < this.boxplotHTESFL.LAI) {
						medicao.insights.push({
							message: outliersMessage.HT_ABAIXO_ESTRATO,
							source: this.boxplotHTESFL.LAI,
						})
					}

					if (
						this.boxplotDAPHTESFL &&
						this.boxplotDAPHTESFL.LAS &&
						medicao.dap / medicao.ht > this.boxplotDAPHTESFL.LAS
					) {
						medicao.insights.push({
							message: outliersMessage.DAP_HT_ABAIXO_ESTRATO,
							source: this.boxplotDAPHTESFL.LAS,
						})
					}

					if (
						this.boxplotDAPHTESFL &&
						this.boxplotDAPHTESFL.LAI &&
						medicao.dap / medicao.ht < this.boxplotDAPHTESFL.LAI
					) {
						medicao.insights.push({
							message: outliersMessage.DAP_HT_ACIMA_ESTRATO,
							source: this.boxplotDAPHTESFL.LAI,
						})
					}
				}

				// Plantio
				const plantio = medicao.plantio
				const categoriaArvore = medicao.categoriaDaArvore
				const dap = medicao.dap
				const altura = medicao.ht

				if (Array.isArray(this.boxPlotDAPPlantio) && this.boxPlotDAPPlantio.length > 0) {
					const boxplotDAP = this.boxPlotDAPPlantio.find(
						(boxplot) => boxplot.plantio === plantio && boxplot.categoria === categoriaArvore,
					)

					if (boxplotDAP != undefined) {
						if (dap > boxplotDAP.quartis.LAS) {
							medicao.insights.push({
								message: `${outliersMessage.DAP_ACIMA_PLANTIO} ${plantio}`,
								source: boxplotDAP.quartis.LAS,
							})
						}

						if (dap < boxplotDAP.quartis.LAI) {
							medicao.insights.push({
								message: `${outliersMessage.DAP_ABAIXO_PLANTIO} ${plantio}`,
								source: boxplotDAP.quartis.LAI,
							})
						}
					}

					if (altura != null) {
						const boxplotAltura = this.boxPlotAlturaPlantio.find(
							(boxplot) => boxplot.plantio === plantio && boxplot.categoria === categoriaArvore,
						)
						if (boxplotAltura !== undefined) {
							if (altura > boxplotAltura.quartis.LAS) {
								medicao.insights.push({
									message: `${outliersMessage.HT_ACIMA_PLANTIO} ${plantio}`,
									source: boxplotAltura.quartis.LAS,
								})
							}

							if (altura < boxplotAltura.quartis.LAI) {
								medicao.insights.push({
									message: `${outliersMessage.HT_ABAIXO_PLANTIO} ${plantio}`,
									source: boxplotAltura.quartis.LAI,
								})
							}
						}
					} else {
						console.log('boxplotDAP undefined')
					}

					const boxPlotDAPAlturaPlantio = this.boxPlotDAPAlturaPlantio.find(
						(boxplot) => boxplot.plantio === plantio && boxplot.categoria === categoriaArvore,
					)
					if (boxPlotDAPAlturaPlantio !== undefined) {
						if (dap / altura > boxPlotDAPAlturaPlantio.quartis.LAS) {
							medicao.insights.push({
								message: `${outliersMessage.DAP_HT_ACIMA_PLANTIO} ${plantio}`,
								source: boxPlotDAPAlturaPlantio.quartis.LAS,
							})
						}

						if (dap / altura < boxPlotDAPAlturaPlantio.quartis.LAI) {
							medicao.insights.push({
								message: `${outliersMessage.DAP_HT_ABAIXO_PLANTIO} ${plantio}`,
								source: boxPlotDAPAlturaPlantio.quartis.LAI,
							})
						}
					}
				}
			}
		},
		validaLimitesHTxIdade(medicao) {
			if (medicao.dataPlantio && medicao.dataColeta) {
				const idadePlantio = this.idadePlantio(medicao.dataPlantio, medicao.dataColeta)

				const limites = this.limitesHTxIdade(idadePlantio)

				if (medicao.ht > limites.LAS)
					medicao.insights.push({
						message: outliersMessage.HT_ACIMA_PLANTIO_IDADE,
						source: limites.LAS,
					})
				if (medicao.ht < limites.LAI)
					medicao.insights.push({
						message: outliersMessage.HT_ABAIXO_PLANTIO_IDADE,
						source: limites.LAI,
					})
			}
		},
		validaLimitesDAPHTxIdade(medicao) {
			if (medicao.dataPlantio && medicao.dataColeta) {
				const idadePlantio = this.idadePlantio(medicao.dataPlantio, medicao.dataColeta)
				const limites = this.limitesDAPHTxIdade(idadePlantio)

				if (medicao.dap / medicao.ht > limites.LAS)
					medicao.insights.push({
						message: outliersMessage.DAP_HT_ACIMA_PLANTIO_IDADE,
						source: limites.LAS,
					})
				if (medicao.dap / medicao.ht < limites.LAI)
					medicao.insights.push({
						message: outliersMessage.DAP_HT_ABAIXO_PLANTIO_IDADE,
						source: limites.LAI,
					})
			}
		},

		limitesHTxIdade(idade) {
			//limite de aviso superior
			const LAS = Math.exp(3.2202694 + 0.2460725 * Math.log(idade) - (0.6868766 * 1) / idade)
			//limite de aviso inferior
			const LAI = Math.exp(2.2332588 + 0.3121552 * Math.log(idade) - (0.6089776 * 1) / idade)
			//limite de erro superior
			const LES = LAS + LAS * 0.15
			//limite de erro inferior
			const LEI = LAI + LAI * 0.15

			return {
				LAS,
				LAI,
				LES,
				LEI,
			}
		},
		limitesDAPHTxIdade(idade) {
			//limite de aviso superior
			const LAS =
				1.4459113233 +
				-0.3613213214 * idade +
				0.0698935354 * Math.pow(idade, 2) +
				-0.0046931676 * Math.pow(idade, 3) +
				0.0001022883 * Math.pow(idade, 4)
			//limite de aviso inferior
			const LAI =
				7.442517e-1 +
				-1.403595e-1 * idade +
				2.243259e-2 * Math.pow(idade, 2) +
				-1.358378e-3 * Math.pow(idade, 3) +
				2.856334e-5 * Math.pow(idade, 4)
			//limite de erro superior
			const LES = LAS + LAS * 0.15
			//limite de erro inferior
			const LEI = LAI + LAI * 0.15

			return {
				LAS,
				LAI,
				LES,
				LEI,
			}
		},
	},
}

export default mixins
